<template>
  <div id="holacon-live-login-screen">
    <div class="login-screen-background">
      <div class="login-screen-panel">
        <div class="login-screen-panel-form">
          <div class="form-header-container">
            <h1>{{ $t("login.welcome") }}</h1>
            <p>
              {{ $t("login.desc") }}
              <br />
              {{ $t("login.desc2") }}
            </p>
          </div>

          <md-tabs md-alignment="centered" class="login-tabs" :md-active-tab="this.fastLogin.activationCode != null ? 'tab-pages' : null">
            <md-tab id="tab-home" :md-label="$t('login.withemailpass')">
              <div class="form-inputs-container" @keydown.enter.exact.prevent @keyup.enter.exact="login">
                <div class="custom-input email icon" :class="hasError('email')">
                  <label>{{ $t("login.email.title") }}</label>
                  <el-input placeholder="..." type="email" v-model="form.email" v-on:input="response.validationErrors.length ? (response.validationErrors = []) : ''"><i slot="prefix" class="fas fa-user"></i></el-input>
                  <span class="md-error">{{ errorMessage("email") }}</span>
                </div>

                <div class="custom-input password icon" :class="hasError('password')">
                  <label>{{ $t("login.password.title") }}</label>

                  <el-input :type="showpwd != true ? 'password' : 'text'" placeholder="..." v-model="form.password" v-on:input="response.validationErrors.length ? (response.validationErrors = []) : ''">
                    <i slot="prefix" class="fas fa-lock"></i>
                    <i slot="suffix" class="fa show-pwd" :class="showpwd != true ? 'fa-eye' : 'fa-eye-slash'" @click="showpwd = !showpwd"></i>
                  </el-input>

                  <span class="md-error">{{ errorMessage("password") }}</span>
                </div>

                <div class="form-confirm">
                  <el-button type="primary" :loading="isLoading" :disabled="isLoading" icon="fas fa-sign-in-alt" @click="login">{{ !isLoading ? $t("login.login") : $t("wait") }}</el-button>
                </div>

                <div class="form-confirm pt-0 visible-xs">
                  <button class="outline mono" @click="$router.push({ name: 'register' })">{{ $t("register.register") }}</button>
                </div>
                <div class="form-confirm pt-0">
                  <button class="outline mono" @click="$router.push({ name: 'home' })">{{ $t("register.backButton") }}</button>
                </div>
                <div class="forgot-pwd-button">
                  <router-link :to="{ name: 'forgot-password' }">{{ $t("login.forgot_password") }}</router-link>
                </div>
              </div>
            </md-tab>

            <md-tab id="tab-pages" :md-label="$t('login.fastLogin')">
              <div class="form-inputs-container" @keydown.enter.exact.prevent @keyup.enter.exact="sendFastLogin">
                <div class="custom-input text icon" :class="(emailRequired ? 'disabled' : '') + hasError('activationCode')">
                  <label>{{ $t("login.activationCode") }}</label>
                  <el-input v-mask="'######-#######'" placeholder="######-#######" v-model="fastLogin.activationCode" v-on:input="response.validationErrors.length ? (response.validationErrors = []) : ''" :disabled="emailRequired"><i slot="prefix" class="fas fa-key"></i></el-input>
                  <span class="md-error">{{ errorMessage("activationCode") }}</span>
                </div>

                <div class="custom-input email icon" :class="hasError('activationEmail')" v-if="emailRequired">
                  <label>{{ $t("login.email.title") }}</label>
                  <el-input placeholder="..." type="email" v-model="fastLogin.email" :disabled="passwordRequired" v-on:input="response.validationErrors.length ? (response.validationErrors = []) : ''"><i slot="prefix" class="fas fa-user"></i></el-input>
                  <span class="md-error">{{ errorMessage("activationEmail") }}</span>
                </div>
                <div class="custom-alert-input" type="info" :closable="false" v-if="passwordRequired">
                  <template v-if="$i18n.locale == 'tr'">
                    <p>
                      Girmiş olduğunuz aktivasyon koduna ait <span class="bold">"{{ fastLogin.email }}"</span> e-posta adresiyle daha önce hesap oluşturduğunuz için bu hesaba ait şifrenizi girmeniz gerekmektedir.
                    </p>
                    <p>
                      <span class="bold">"{{ fastLogin.email }}"</span> adresine bağlı hesabınızın şifresini hatırlamıyorsanız <span class="underline" @click="resendUserEmail">buraya</span> tıklayarak şifrenizin e-posta adresine gönderimini sağlayabilirsiniz. <span class="underline" @click="resendUserEmail">"ŞİFREMİ GÖNDER"</span>
                    </p>
                    <p>
                      <span class="bold">"{{ fastLogin.email }}"</span> e-posta adresine erişiminiz yok ise <span class="underline" @click="$router.push({ name: 'register' })">buraya</span> tıklayarak yeni hesap oluşturabilir ve sonrasında gönderilen yeni aktivasyon kodunu hesabınıza tanımlayabilirsiniz. <span class="underline" @click="$router.push({ name: 'register' })">"YENİ HESAP OLUŞTUR"</span>
                    </p>
                  </template>
                  <template v-else>
                    <p>
                      Due to having previously created an account with the activation code you entered, you need to enter the password associated with this account, which is linked to the email address <span class="bold">"{{ fastLogin.email }}"</span>.
                    </p>
                    <p>
                      If you don't remember the password for your account linked to the email address <span class="bold">"{{ fastLogin.email }}"</span>, you can <span class="underline" @click="resendUserEmail">click here</span> to initiate the password reset process and have the instructions sent to your email address. <span class="underline" @click="resendUserEmail">"SEND MY PASSWORD"</span>
                    </p>
                    <p>
                      If you don't have access to the <span class="bold">"{{ fastLogin.email }}"</span> email address, you can <span class="underline" @click="$router.push({ name: 'register' })">click here</span> to create a new account and then assign the newly sent activation code to your account. <span class="underline" @click="$router.push({ name: 'register' })">"CREATE A NEW ACCOUNT"</span>
                    </p>
                  </template>
                </div>
                <div class="custom-input password icon" :class="hasError('activationEmail')" v-if="passwordRequired">
                  <label>{{ $t("login.password.title") }}</label>
                  <el-input :type="showpwd != true ? 'password' : 'text'" placeholder="..." v-model="fastLogin.password" v-on:input="response.validationErrors.length ? (response.validationErrors = []) : ''">
                    <i slot="prefix" class="fas fa-lock"></i>
                    <i slot="suffix" class="fa show-pwd" :class="showpwd != true ? 'fa-eye' : 'fa-eye-slash'" @click="showpwd = !showpwd"></i>
                  </el-input>
                  <span class="md-error">{{ errorMessage("activationPassword") }}</span>
                </div>

                <div class="custom-checkbox" v-if="settings.whiteLabelSettings.holaconPolicies.length > 0">
              <md-checkbox v-model="fastLogin.checkbox" :class="hasError('checkbox')" @change="response.validationErrors.length ? (response.validationErrors = []) : ''"> </md-checkbox>
              <span v-if="$i18n.locale == 'tr'">
                Holacon,
                <template v-for="item in settings.whiteLabelSettings.holaconPolicies"><a target="_blank" @click.stop="openPolicy(item)">{{ item.title }}</a>, </template>
                sözleşmelerini okudum ve kabul ediyorum.
              </span>
              <span v-else>
                I have read and accept to Holacon,
                <template v-for="item in settings.whiteLabelSettings.holaconPolicies"><a target="_blank" @click.stop="openPolicy(item)">{{ item.title }}</a>, </template>
                policies.
              </span>
            </div>


            <div class="custom-checkbox" v-if="settings.whiteLabelSettings.policies.length > 0">
              <md-checkbox v-model="fastLogin.checkbox2" :class="hasError('checkbox2')" @change="response.validationErrors.length ? (response.validationErrors = []) : ''"> </md-checkbox>
              <span v-if="$i18n.locale == 'tr'">
                {{ settings.whiteLabelSettings.metaTitle }},
                <template v-for="item in settings.whiteLabelSettings.policies"><a target="_blank" @click.stop="openPolicy(item)">{{ item.title }}</a>, </template>
                sözleşmelerini okudum ve kabul ediyorum.
              </span>
              <span v-else>
                I have read and accept to {{ settings.whiteLabelSettings.metaTitle }},
                <template v-for="item in settings.whiteLabelSettings.policies"><a target="_blank" @click.stop="openPolicy(item)">{{ item.title }}</a>, </template>
                policies.
              </span>
            </div>


                

                <p>{{ (emailRequired && !passwordRequired) ? $t("login.useactiveemail") : $t("login.activationinfo") }}</p>

                <div class="form-confirm">
                  <el-button type="primary" :loading="isLoading" :disabled="isLoading" icon="fas fa-sign-in-alt" @click="sendFastLogin">{{ !isLoading ? (!emailRequired ? $t("login.fastLoginBtn") : $t("login.login")) : $t("wait") }}</el-button>
                </div>

                <div class="form-confirm pt-0 visible-xs">
                  <button class="outline mono" @click="$router.push({ name: 'register' })">{{ $t("register.register") }}</button>
                </div>
              </div>
            </md-tab>
          </md-tabs>

          <!-- <div class="form-social-container" v-if="$route.params.slug == 'holacon'">
            <h3>{{ $t("login.usesocialacc") }}</h3>

            <div class="form-confirm" v-if="$route.params.slug == 'holacon'">
              <button class="color-fb btn-xl" :class="isLoading ? 'disabled' : ''" :disabled="isLoading" @click="triggerFacebook">
                <i class="fa fa-facebook"></i>
                {{ !isLoading ? $t("login.facebook") : $t("wait") }}
              </button>
            </div>
          </div> -->

          <div class="download-app visible-xs">
            <h3>{{ $t("login.downloadapp") }}</h3>
            <a target="_blank" :href="$store.state.application.iosLink" v-if="$store.state.application.iosLink != null">
              <img src="/static/apple.png" alt="download" />
            </a>
            <a target="_blank" :href="$store.state.application.androidLink" v-if="$store.state.application.androidLink != null">
              <img src="/static/google.png" alt="download" />
            </a>
          </div>
        </div>

        <div class="login-screen-panel-salute bg-1">
          <div class="login-logo-area" :class="$route.params.slug != 'holacon' ? 'has-whitelabel' : ''">
            <img v-if="$route.params.slug != 'holacon'" :src="$imageus + $store.state.application.image + '?width=200&height=200)'" class="whitelabel-logo" />
            <img v-else src="/static/logo-light.svg" class="logo" />
          </div>

          <div class="salute-container">
            <h1>{{ $t("login.title") }}</h1>
            <p>{{ $t("login.description") }}</p>
          </div>

          <div class="form-confirm hidden-xs">
            <button class="button-light" @click="$router.push({ name: 'register' })">{{ $t("register.register") }}</button>
          </div>

          <div class="download-app hidden-xs">
            <a target="_blank" :href="$store.state.application.iosLink" v-if="$store.state.application.iosLink != null">
              <img src="/static/apple.png" alt="download" />
            </a>
            <a target="_blank" :href="$store.state.application.androidLink" v-if="$store.state.application.androidLink != null">
              <img src="/static/google.png" alt="download" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="policyModal" class="default" :close-on-click-modal="false" append-to-body center destroy-on-close :title="policy.title">
      <div class="custom-modal" v-if="policy.details != null">
        <div class="modal-body no-footer" v-html="policy.details"></div>
      </div>
    </el-dialog>
    <md-snackbar :class="response.hasError ? 'warning' : 'success'" :md-position="'center'" :md-duration="4000" :md-active.sync="response.hasError" md-persistent>
      <i class="fa" :class="response.hasError ? 'fa-exclamation-triangle' : 'fa-check'"></i>
      <span>{{ response.message }}</span>
    </md-snackbar>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Login",
  data() {
    return {
      policy: {},
      policyModal: false,
      policies: [],
      fastLogin: {
        activationCode: null,
        email: null,
        password: null,
        checkbox: false,
        checkbox2: false
      },
      showpwd: false,
      form: {
        email: null,
        password: null
      },
      isLoading: false,
      isError: false,
      response: {
        hasError: false,
        message: null,
        validationErrors: []
      },
      eventid: null,
      emailRequired: false,
      passwordRequired: false,
      settings: {
        whiteLabelSettings: {  
          policies: [],
          holaconPolicies: []
        }
      }
    };
  },
  async created() {
    var settingsResponse = await axios.post("definition/getApplicationsettings", {
      id: this.currentApplication.id
    });
    this.settings = settingsResponse.data.data;


    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get('openPolicy');
    if(myParam != null)
    {
      let found = this.settings.whiteLabelSettings.policies.find(x => x.slug == myParam)
      if(found != null)
      {
        this.openPolicy(found)
      }
      else
      {
        let found = this.settings.whiteLabelSettings.holaconPolicies.find(x => x.slug == myParam)
        if(found != null)
        {
          this.openPolicy(found)
        }
      }
      
    }

  },
  beforeMount() {
    this.getUrlParams();
  },
  computed: {
    currentApplication() {
      return this.$store.getters.getApplication;
    }
  },
  async mounted() {
    var res = await this.$store.dispatch("getApplicationPolicies", this.currentApplication.id);
    this.policies = res.data.data.items;
    window.FB.init({
      appId: this.$store.state.application.facebookAppID,
      cookie: true,
      xfbml: true,
      version: "v7.0"
    });
  },
  watch: {
    "form.email": function() {
      if (this.form.email != null) {
        this.form.email = this.form.email
          .toString()
          .toLowerCase()
          .trim();
      }
    }
  },
  methods: {
    openPolicy(item) {
      this.policy = item;
      if (this.policy == null) {
        this.$message.info("Sözleşme bulunamadı");
        return;
      }
      this.policyModal = true;
    },
    triggerFacebook() {
      window.FB.login(
        response => {
          this.facebookLogin(response.authResponse.accessToken);
        },
        { scope: "email" }
      );
    },
    async facebookLogin(token) {
      try {
        var response = await axios.post("login/signinwithfacebook", {
          accessToken: token
        });
        this.response = response.data;

        if (response.data.hasError == false) {
          this.$store.commit("setToken", response.data.data.token);

          var userResponse = await axios.post("account/get");
          this.$store.commit("setUser", userResponse.data.data.user);
          this.$store.commit("setNotify", userResponse.data.data);
          localStorage.setItem("token", response.data.data.token);
          this.$router
            .push({
              name: "home",
              params: { slug: this.$route.params.slug }
            })
            .catch(e => {});
        }
      } catch (err) {
        this.response = {
          hasError: true,
          validationErrors: [],
          message: err
        };
      }

      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    async login() {
      this.isLoading = true;

      try {
        if (this.form.email != null) {
          this.form.email = this.form.email
            .toString()
            .toLowerCase()
            .trim();
        }

        var response = await axios.post("login/signin", this.form);
        this.response = response.data;

        if (response.data.hasError == false) {
          this.$store.commit("setToken", response.data.data.token);

          var userResponse = await axios.post("account/get");
          this.$store.commit("setUser", userResponse.data.data.user);
          this.$store.commit("setNotify", userResponse.data.data);
          localStorage.setItem("token", response.data.data.token);
          this.$router.push({
            name: "home",
            params: { slug: this.$route.params.slug }
          });
        }
      } catch (err) {
        this.response = {
          hasError: true,
          validationErrors: [],
          message: err
        };
      }

      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    async resendUserEmail() {
      axios.defaults.headers["applicationID"] = this.currentApplication.id;
      try {
        var res = await axios.post("Login/ResendUserPasswordWithEmail", { email: this.fastLogin.email });
        if(!res.data.hasError){
          this.$message.success(res.data.message);
        }else {
          this.$message.error(res.data.message);
        }
      } catch (error) {
        console.error("resend user email : ",error);
      }
    },
    async sendFastLogin() {
      this.isLoading = true;

      if (this.settings.whiteLabelSettings.holaconPolicies.length > 0 && this.fastLogin.checkbox == false) {
        this.$message.warning(this.$i18n.t("pleaseCheckPolicy"));
        this.response.validationErrors = [{ key: "checkbox", value: this.$i18n.t("pleaseControlArea") }];
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
        return;
      }

      if (this.settings.whiteLabelSettings.policies.length > 0 && this.fastLogin.checkbox2 == false) {
        this.$message.warning(this.$i18n.t("pleaseCheckPolicy"));
        this.response.validationErrors = [{ key: "checkbox2", value: this.$i18n.t("pleaseControlArea") }];
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
        return;
      }

      var res = await axios.post("login/fastlogin", {
        activationCode: this.fastLogin.activationCode,
        emailAddress: this.fastLogin.email,
        password: this.fastLogin.password
      });
      this.response.validationErrors = res.data.validationErrors;

      if (res.data.hasError == true || this.response.validationErrors.length > 0) {
        if (res.data.data != null) {
          this.fastLogin.email = res.data.data.email;
        }
        if(!res.data.validationErrors.some(x => x.key == "emailAddress") && !res.data.validationErrors.some(x => x.key == "password")){
          this.$message.error(res.data.message);
        }
        if (res.data.validationErrors.some(x => x.key == "emailAddress")) {
          this.emailRequired = true;
          this.$message.error(this.$t("emailRequiredFastLogin"));
        }
        if (res.data.validationErrors.some(x => x.key == "password")) {
          this.emailRequired = true;
          this.emailDisabled = true;
          this.passwordRequired = true;
          this.$message.error(this.$t("passwordRequiredFastLogin"));
        }
      } else {
        this.$store.commit("setToken", res.data.data.token);
        var eventid = res.data.data.eventId;

        var userResponse = await axios.post("account/get");
        this.$store.commit("setUser", userResponse.data.data.user);
        this.$store.commit("setNotify", userResponse.data.data);
        localStorage.setItem("token", res.data.data.token);

        this.$store.dispatch("getEventBySlug", {
          id: eventid,
          slug: res.data.data.slug,
          route: true
        });
      }

      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    hasError(key) {
      if (this.response.validationErrors.some(k => k.key == key)) {
        return "md-invalid";
      } else {
        return "";
      }
    },
    errorMessage(key) {
      if (this.response.validationErrors.some(k => k.key == key)) {
        return this.response.validationErrors.find(k => k.key == key).value;
      } else {
        return "";
      }
    },
    getUrlParams() {
      let urlParams = new URLSearchParams(window.location.search);
      let activationCode = urlParams.get("activationCode");
      if (activationCode != null) {
        this.fastLogin.activationCode = activationCode;
        this.sendFastLogin();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Login.vue